module.exports = __webpack_public_path__ + "img/tuan2-1.2562dde2.png";